import {Component, Inject, Input, LOCALE_ID} from '@angular/core';
import {FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {
  HUMANIA_EMMA_V2_CANCER_RIDER_COVERAGE_AMOUNT_INTERVAL_EMMA_PRO,
  HUMANIA_EMMA_V2_CANCER_RIDER_MAX_COVERAGE,
  HUMANIA_EMMA_V2_CANCER_RIDER_MIN_COVERAGE,
  RiderType,
} from '@emma-labs/shared/typescript';
import {untilDestroyed} from '@ngneat/until-destroy';
import {DropdownModule} from 'primeng/dropdown';
import {ProtectionService} from '../../../../../services/protection.service';
import {CoverageCardComponent} from '../../coverage-card/coverage-card.component';
import {BaseRiderCardComponent} from '../base-rider-card.component';

@Component({
  selector: 'em-cancer-rider-card',
  templateUrl: './cancer-rider-card.component.html',
  imports: [CoverageCardComponent, DropdownModule, ReactiveFormsModule],
})
export class CancerRiderCardComponent extends BaseRiderCardComponent {
  @Input({required: true}) override set selectedRiderCoverageAmount(coverageAmount: number | undefined) {
    this.coverageAmountOptions = this.protectionService.getCoverageDropdownOptions(
      HUMANIA_EMMA_V2_CANCER_RIDER_MIN_COVERAGE,
      HUMANIA_EMMA_V2_CANCER_RIDER_COVERAGE_AMOUNT_INTERVAL_EMMA_PRO,
      HUMANIA_EMMA_V2_CANCER_RIDER_MAX_COVERAGE,
      true,
    );

    this.form.controls.coverageAmount.setValue(coverageAmount, {emitEvent: false});
  }

  constructor(
    override readonly fb: FormBuilder,
    private readonly protectionService: ProtectionService,
    @Inject(LOCALE_ID) locale: string,
  ) {
    super(fb, locale);

    this.form.controls.coverageAmount.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      this.coverageSelected.emit({amount: value ?? undefined, type: RiderType.CANCER});
    });
  }

  onSelect(): void {}

  setProducts(): void {}
}
